import axios from 'axios';
import types from './types';

axios.defaults.withCredentials = true;

// Every agent instance reports only the ports of its own transport, so each one
// publishes under its own source and the reducer merges them all. Callers that do
// not identify themselves share this single source, which keeps the old behaviour.
export const DEFAULT_PORT_SOURCE = 'default';

function actionGetPortsFetchAction(ports, source) {
  return { type: types.GET_PORTS, payload: { statusPorts: 'fetch', ports, source } };
}

export function getPorts(ports, source = DEFAULT_PORT_SOURCE) {
  return (dispatch) => {
    dispatch(actionGetPortsFetchAction(ports, source));
  };
}

function actionGetAgentPortsFetchAction(ports, source) {
  return { type: types.GET_AGENT_PORTS, payload: { statusPorts: 'fetch', ports, source } };
}

export function getAgentPorts(ports, source = DEFAULT_PORT_SOURCE) {
  return (dispatch) => {
    dispatch(actionGetAgentPortsFetchAction(ports, source));
  };
}

function actionGetMessageFetchAction(msg) {
  return { type: types.GET_NEW_MESSAGE, payload: { statusMsg: 'fetch', msg } };
}

export function getNewMessage(msg) {
  return (dispatch) => {
    const fixedNewLineMsg = msg.replace(/[\r\n]/g, '');
    dispatch(actionGetMessageFetchAction(fixedNewLineMsg));
  };
}

function actionGetMessageProgressFetchAction(stateMsg, progress) {
  return { type: types.GET_NEW_STATE, payload: { statusState: 'fetch', stateMsg, progress } };
}

export function getNewProgress(msg, progress) {
  return (dispatch) => {
    const fixedNewLineMsg = msg.replace(/[\r\n]/g, '');
    dispatch(actionGetMessageProgressFetchAction(fixedNewLineMsg, progress));
  };
}

function actionGetStateFetchAction(stateMsg) {
  return { type: types.GET_NEW_STATE, payload: { statusState: 'fetch', stateMsg } };
}

export function getNewState(msg) {
  return (dispatch) => {
    const fixedNewLineMsg = msg.replace(/[\r\n]/g, '');
    dispatch(actionGetStateFetchAction(fixedNewLineMsg));
  };
}

export const setNewMessage = (dispatch) => (message) => {
  const fixedNewLineMsg = message.replace(/[\r\n]/g, '');
  dispatch(actionGetStateFetchAction(fixedNewLineMsg));
};


function actionGetMonitorMessageFetchAction(monitorMsgs) {
  return { type: types.GET_NEW_MONITOR_MESSAGE, payload: { statusMonitorMsg: 'fetch', monitorMsgs } };
}

export function getNewMonitorMessage(msg) {
  return (dispatch) => {
    const fixedNewLineMsg = msg;
    dispatch(actionGetMonitorMessageFetchAction(fixedNewLineMsg));
  };
}

function actionResetStatusFetch(ObjectToAssign) {
  return { type: types.BLOQUES_RESET_STATUS, payload: ObjectToAssign };
}

export function actionResetStatus(ObjectToAssign) {
  return (dispatch) => {
    dispatch(actionResetStatusFetch(ObjectToAssign));
  };
}
